export const UPLOAD_DOCUMENT = "UPLOAD_DOCUMENT";

export function uploadDocument(selectedFile, user, path) {
  console.log("Action UPLOAD_DOCUMENT", user, path);
  return { type: UPLOAD_DOCUMENT, data: { selectedFile, user, path } };
}
